<!--
 * @Author: your name
 * @Date: 2021-09-20 08:59:53
 * @LastEditTime: 2021-12-26 16:17:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\views\PC\Skills\Skills.vue
-->
<template>
  <div class="bounty-message">
    <bounty-back :title="$t('My.My')" @goBack="goBack"></bounty-back>
    <div class="title">
      <span class="sub-title">{{$t('My.message.subTitle')}}</span>
      <div>
        <span class="clear-all" @click="()=>{showTip2 = true}">{{$t('My.message.ClearAllNotice')}}</span>
        <span class="remove-read" @click="removeUnread">{{$t('My.message.removeUnread')}}</span>
      </div>
    </div>
    <div class="list" v-for="(item,index) in list" :key="index" @click="showTipFn(item)">
      <div class="top-des">
        <div class="top-left">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
            <circle cx="10" cy="10" r="10" fill="#EEEEEE"/>
            </mask>
            <g mask="url(#mask0)">
            <circle cx="10" cy="10" r="10" fill="url(#paint0_linear)"/>
            <path d="M7.19092 5.54688H10.5909C11.4887 5.54688 12.1909 5.78243 12.6976 6.25354C13.2131 6.72465 13.4709 7.33799 13.4709 8.09354C13.4709 8.57354 13.342 9.00021 13.0843 9.37354C12.8265 9.73799 12.4976 9.98688 12.0976 10.1202C12.5776 10.2358 12.9731 10.498 13.2843 10.9069C13.6043 11.3069 13.7643 11.7913 13.7643 12.3602C13.7643 13.1335 13.4976 13.7691 12.9643 14.2669C12.4309 14.7558 11.7243 15.0002 10.8443 15.0002H7.19092V5.54688ZM9.00425 9.45354H10.3109C10.7287 9.45354 11.0576 9.34688 11.2976 9.13354C11.5376 8.92021 11.6576 8.63132 11.6576 8.26688C11.6576 7.90243 11.5376 7.61799 11.2976 7.41354C11.0665 7.20021 10.7331 7.09354 10.2976 7.09354H9.00425V9.45354ZM9.00425 13.4669H10.4976C10.942 13.4669 11.2887 13.3602 11.5376 13.1469C11.7954 12.9247 11.9243 12.6224 11.9243 12.2402C11.9243 11.858 11.7998 11.5513 11.5509 11.3202C11.3109 11.0891 10.9687 10.9735 10.5243 10.9735H9.00425V13.4669Z" fill="white"/>
            </g>
            <defs>
            <linearGradient id="paint0_linear" x1="0" y1="0" x2="21.1673" y2="1.32296" gradientUnits="userSpaceOnUse">
            <stop stop-color="#A737FF"/>
            <stop offset="1" stop-color="#18D6BE"/>
            </linearGradient>
            </defs>
          </svg>
          <div>{{item.title}}</div>
        </div>
        <div class="top-right">
          <span>{{item.time}}</span>
          <div v-if="!item.status" class="red">1</div>
        </div>
      </div>
      <div class="bottom-des ellipsis3">{{item.des}}</div>
    </div>
    <div v-if="!list.length" style="color: #bbb" class="no-data">{{$t('HotTask.NoData')}}</div>
    <div style="text-align: right;">
      <div v-if="showLoadMore" class="load-more" @click="getList">Load More</div>
    </div>
    <bounty-tip v-if="showTip" :content="readTip" :cancelBtn="$t('My.message.cancel')" :sureBtn="$t('My.message.yes')" @sure="close" @close="close"></bounty-tip>
    <bounty-tip v-if="showTip2" :content="$t('My.message.ClearAllNotice')" :cancelBtn="$t('My.message.cancel')" :sureBtn="$t('My.message.yes')" @sure="clearAll" @close="()=>{showTip2 = false}"></bounty-tip>
  </div>
</template>

<script>

import { getMyNoticeList, getNoticeById, updateToReadAll, removeMyNotice } from '@/api/bounty.js'

export default {
  name: 'bountyMessage',
  data () {
    return {
      showTip2: false,
      showTip: false,
      readTip: '',
      showLoadMore: false,
      count: 0,
      list: [
        // {
        //   title: 'Bounty quest status changed',
        //   time: '13:22',
        //   des: 'Bounty quest status changed',
        //   status: 0
        // }
      ],
      showMore: true
    }
  },
  props: {
  },
  mounted () {
    this.getList()
  },
  methods: {
    /**
     * @description: 消息弹窗关闭
     * @param {*}
     * @return {*}
     */
    close () {
      this.count = 0
      this.showTip = false
      this.readTip = ''
      this.getList()
    },
    /**
     * @description:
     * @param {*} data
     * @return {*}
     */
    showTipFn (data) {
      this.readTip = data.des
      getNoticeById({ id: data.id }).then(res => {
        if (!res.code) {
          this.showTip = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 获取message列表
     * @param {*}
     * @return {*}
     */
    goList () {
      // 获取message列表
      window.location.href = this.helpHref
    },
    /**
     * @description: 返回
     * @param {*}
     * @return {*}
     */
    goBack () {
      this.$emit('goBack')
    },
    /**
     * @description: 查询我的消息列表
     * @param {*}
     * @return {*}
     */
    getList () {
      getMyNoticeList({
        count: this.count,
        pageSize: 50
      }).then(res => {
        if (!res.code) {
          if (res.data && res.data.noticeList.length) {
            this.count = this.count + res.data.noticeList.length
            if (res.data.noticeList.length === 50) {
              this.showLoadMore = true
            } else {
              this.showLoadMore = false
            }
            this.list = res.data.noticeList.map(item => {
              return {
                id: item.id,
                title: item.title_en,
                time: item.sendingTime,
                des: item.body_en,
                status: Number(item.read)
              }
            })
          } else {
            this.list = []
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 移除未读
     * @param {*}
     * @return {*}
     */
    removeUnread () {
      updateToReadAll().then(res => {
        if (!res.code) {
          this.$message({
            type: 'success',
            offset: 120,
            message: 'success'
          })
          this.count = 0
          this.getList()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 移除全部消息
     * @param {*}
     * @return {*}
     */
    clearAll () {
      removeMyNotice().then(res => {
        if (!res.code) {
          this.$message({
            type: 'success',
            offset: 120,
            message: 'success'
          })
          this.showTip2 = false
          this.count = 0
          this.getList()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/gloabal.scss';
.saveBtn{
  display: inline-block;
  background: linear-gradient(96.34deg, #A737FF 0%, #18D6BE 100%);
  border-radius: 26px;
  cursor: pointer;
  margin-top: 26px;
  padding: 12px 32px;
  font-family: $fontFamilyCircularStd;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
}
.bounty-message{
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    .sub-title{
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: bold;
      font-size: 34px;
    }
    .remove-read{
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: normal;
      font-size: 26px;
      // line-height: 20px;
      padding: 18px 24px;
      background: #35353D;
      border-radius: 12px;
      color: #FF6262;
      cursor: pointer;
      margin-left: 20px;
    }
    .clear-all{
      cursor: pointer;
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: normal;
      font-size: 26px;
      padding: 18px 24px;
      background: #35353D;
      border-radius: 12px;
      color: #FF6262;
    }
  }
  .list{
    margin-bottom: 30px;
    background: #35353D;
    border-radius: 12px;
    padding: 24px;
    .top-des{
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      .top-left{
        display: flex;
        align-items: center;
        svg{
          margin-right: 12px;
        }
        div{
          font-family: $fontFamilyCircularStd;
          font-style: normal;
          font-weight: normal;
          font-size: 26px;
          line-height: 33px;
          color: #BBBBBB;
        }
      }
      .top-right{
        display: flex;
        align-items: center;
        span{
          color: #BBBBBB;
          font-family: $fontFamilyCircularStd;
          font-style: normal;
          font-weight: normal;
          font-size: 26px;
          line-height: 33px;
          margin-right: 12px;
        }
        div{
          color:#fff;
          width: 24px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          font-family: $fontFamilyCircularStd;
          font-style: normal;
          font-weight: normal;
          font-size: 22px;
          border-radius: 100%;
        }
        .red{
          background-color: #FF6262;
        }
      }
    }
    .bottom-des{
      cursor: pointer;
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: normal;
      font-size: 28px;
      line-height: 35px;
      margin-top: 16px;
    }
  }
}
</style>
